import { ICuestionarioPreg, IQResp, IQRespEdit, IRespuestasDePreg } from 'src/model/candidato-api'
import { T_RespModel } from './CVModel'
import { FileUploader } from 'angular-file-upload'
import moment from 'moment'
import { chain, trim } from 'lodash'

export class CVResp {
  private uploader: FileUploader
  idx = 0

  respOriginal: IRespuestasDePreg | undefined = undefined

  constructor(
    private q: ICuestionarioPreg,
    private superq: ICuestionarioPreg,
    private respmodel: T_RespModel,
    idx?: number
  ) {
    this.idx = idx || 0
  }

  conOriginal(listaRespuestas: IRespuestasDePreg | undefined) {
    this.respOriginal = listaRespuestas
  }

  validaPreg() {
    return (this.respmodel.valid = this._validaPreg())
  }

  private _validaPreg() {
    if (!this.q.req) return true

    switch (this.q.tq) {
      case 'FILE':
        try {
          return !!this._nombreFichero()
        } catch (e) {
          return false
        }

      case 'MULTIPLE':
        return this.__mutipleActivos().length > 0

      case 'TEXT':
      case 'EMAIL':
      case 'MEMO':
      case 'PARAM':
      case 'PARAM2':
      case 'PARAMOCULTO':
        return !!this._defStr(this.respmodel.t)

      case 'NUMBER':
        return !!this._def(this.respmodel.n)

      case 'DATE':
        return !!this._def(this.respmodel.d)

      case 'YESNO':
        return this.respmodel.yesno.yes || this.respmodel.yesno.no

      case 'SELECT':
        return !!(this._def(this.respmodel.opt) && this.respmodel.opt)

      default:
        return true
    }
  }

  generaReq(): IQResp {
    // sacar valor según el tipo
    var req: IQResp = {
      idref: this.q.qref,
      idsupref: this.superq && this.superq.qref,
      idx: 0,
      empty: true,
      idopt: null, // no se usa
      opt: null, // para un multiple
      opts: null, // si hay varias opciones marcadas
      text: null,
      num: null,
      f: null,
      val: null,
      sel: null, // para un select
      fil: null, // para files
      yndet: null, // para yesno
    }

    this.__generaModel(req)

    return req
  }

  generaReqEdit(): IQRespEdit[] {
    // los tipo files no se pasan en edición
    if (this.esTipoFile()) {
      return []
    }

    // sacar valor según el tipo
    var req: IQRespEdit = {
      idref: this.q.qref,
      idsupref: this.superq && this.superq.qref,
      idx: 0,
      empty: true,
      idopt: null, // no se usa
      opt: null, // para un multiple
      opts: null, // si hay varias opciones marcadas
      text: null,
      num: null,
      f: null,
      val: null,
      sel: null, // para un select
      fil: null, // para files
      yndet: null, // para yesno
      idresporig: this._respOriginal(), // la respuesta original
    }

    this.__generaModel(req)

    return [req]
  }

  private _respOriginal() {
    if (this.respOriginal?.respuestas.length) {
      return this.respOriginal.respuestas[0].idresp
    }

    return null
  }

  private __generaModel(req: IQResp) {
    req.idx = this.idx

    switch (this.q.tq) {
      case 'TEXT':
      case 'MEMO':
      case 'EMAIL':
      case 'PARAM':
      case 'PARAM2':
      case 'PARAMOCULTO':
        req.text = this._defStr(this.respmodel.t) || null
        req.empty = !req.text
        break

      case 'DATE':
        req.f = (this._def(this.respmodel.d) && new Date(this.respmodel.d)) || null
        req.empty = !req.f
        break

      case 'NUMBER':
        req.num = (this._def(this.respmodel.n) && this.respmodel.n) || null
        req.empty = !req.num
        break

      case 'FILE':
        req.fil = this._fichero()
        req.empty = !req.fil
        break

      case 'SELECT':
        req.sel = (this._def(this.respmodel.opt) && this.respmodel.opt) || null
        req.empty = !req.sel
        break

      case 'MULTIPLE':
        let activos = this.__mutipleActivos()
        let first = (activos.length && activos[0]) || null
        req.opts = activos
        req.empty = !first

        break

      case 'ROW':
        req.empty = false
        break

      case 'YESNO':
        req.empty = !(this.respmodel.yesno.yes || this.respmodel.yesno.no)

        if (!req.empty) {
          req.val = this.respmodel.yesno.yes || false

          // incluir los detalles
          if (req.val) {
            req.yndet = this.respmodel.yesno.details
          }
        }

        break

      case 'ERROR':

      default:
    }
  }

  private __mutipleActivos() {
    let activos =
      (this.respmodel.opts &&
        chain(this.respmodel.opts)
          .filter((o) => o && o.opt != null)
          .value()) ||
      []

    if (this.q.allowOthers) {
      let others =
        (this.respmodel.others &&
          chain(this.respmodel.others)
            .filter((o) => o && !!trim(o.opt))
            .value()) ||
        []

      return activos.concat(others)
    } else return activos
  }

  private _fichero() {
    try {
      return this._nombreFichero()
    } catch (e) {
      return null
    }
  }

  private _nombreFichero() {
    // debe haber un uploader

    let files = this.uploader.queue

    if (!files || files.length < this.idx + 1) {
      throw new Error('No hay fichero')
    }

    // debe haber al menos idx files
    let f = files[this.idx]

    return f.file.name
  }

  generaFiles() {
    switch (this.q.tq) {
      case 'FILE':
        return [new CVFilePreg(this, this.uploader)]

      default:
        return []
    }
  }

  private _def(val: any) {
    return val != undefined && val != null
  }

  private _defStr(val: string) {
    return this._def(val) && trim(val)
  }

  /**
   * Si es de tipo FILE, el uploader que gestiona los ficheros
   *
   * @param uploader el file uploader
   */
  uploaderFiles(uploader: FileUploader) {
    this.uploader = uploader
  }

  __rellenaTest() {
    switch (this.q.tq) {
      case 'DATE':
        this.respmodel.d = moment().startOf('week').toDate()
        return

      case 'TEXT':
      case 'MEMO':
      case 'EMAIL':
        this.respmodel.t = this.respmodel.t || `==${this.q.q}==${this.idx}==`
        return

      case 'NUMBER':
        this.respmodel.n = this.respmodel.n || 1000 + this.idx
        return
    }
  }

  qref() {
    return this.q.qref
  }

  esTipoFile() {
    return this.q.tq === 'FILE'
  }
}

export class CVFilePreg {
  constructor(private resp: CVResp, private uploader: FileUploader) {}

  filesEnviar() {
    return this.uploader.queue
  }

  get idqref() {
    return this.resp.qref()
  }

  get idx() {
    return this.resp.idx != null ? this.resp.idx + '' : null
  }
}
